import { render, staticRenderFns } from "./select-department.vue?vue&type=template&id=97167dd8&"
import script from "./select-department.vue?vue&type=script&lang=js&"
export * from "./select-department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports